import { h } from "./../../utils/createElement";
import { __extends } from "tslib";
import * as React from 'react';
import * as PropTypes from 'prop-types';
import { consumeTheme } from '../../utils/theme';
import { emptyFn } from '../../utils/helper';
var List = (function (_super) {
    __extends(List, _super);
    function List() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.keys = {};
        _this.renderListItem = function (item, index) {
            var renderItem = _this.props.renderItem;
            var key;
            if (item.key) {
                key = item.key;
            }
            else {
                key = "dui-list-item-" + index;
            }
            _this.keys[index] = key;
            return renderItem(item, index);
        };
        _this.themedRender = function (classNames) {
            var _a = _this.props, prefixCls = _a.prefixCls, className = _a.className, style = _a.style, dataSource = _a.dataSource;
            var classes = classNames(prefixCls, className);
            var ulClass = prefixCls + "-items";
            var items = dataSource.map(_this.renderListItem);
            var cloneItems = [];
            React.Children.forEach(items, function (child, index) {
                cloneItems.push(React.cloneElement(child, {
                    key: _this.keys[index],
                }));
            });
            return (h("div", { className: classes, style: style },
                h("ul", { className: ulClass }, cloneItems)));
        };
        return _this;
    }
    List.prototype.render = function () {
        return consumeTheme(this.themedRender);
    };
    return List;
}(React.Component));
export default List;
List.defaultProps = {
    prefixCls: 'dui-list',
    dataSource: [],
    renderItem: emptyFn,
};
List.propTypes = {
    prefixCls: PropTypes.string,
    style: PropTypes.object,
    className: PropTypes.string,
    dataSource: PropTypes.array,
    renderItem: PropTypes.func,
};
